const DEFAULT_PRODUCT_KEY = "paper-kingdom";
const DEFAULT_PRODUCT_ROUTE_PATH = "/PaperKingdom";

export function normalizeProductRoutePath(routePath?: string) {
  const normalized = (routePath?.trim() || DEFAULT_PRODUCT_ROUTE_PATH)
    .replace(/^\/+/, "")
    .replace(/\/+$/, "");

  return normalized ? `/${normalized}` : DEFAULT_PRODUCT_ROUTE_PATH;
}

export const productKey =
  import.meta.env.VITE_PRODUCT_KEY?.trim() || DEFAULT_PRODUCT_KEY;

export const productRoutePath = normalizeProductRoutePath(
  import.meta.env.VITE_PRODUCT_ROUTE_PATH,
);

export function productPath(path = "/") {
  const suffix = path.replace(/^\/+/, "");
  return suffix ? `${productRoutePath}/${suffix}` : `${productRoutePath}/`;
}
